class SiteElementLayout
    extends QueryElement<HTMLElement> {
    private readonly _site: SiteAssortment;
    
    constructor(element: HTMLElement, site: SiteAssortment) {
        super(element);

        this._site = site;

        this.query("a").createAll<SiteElementLayoutButton, HTMLElement>(a => new SiteElementLayoutButton(a, this));
        this.children()[0].addClass("active");
    }

    setLayout(element:IQueryElement, size: string) {
        this.children().forEach(a => a.removeClass("active"));
        element.addClass("active");
        this._site.setLayout(size);
    }
}

class SiteElementLayoutButton
    extends QueryElement<HTMLElement> {

    constructor(element: HTMLElement, parent: SiteElementLayout) {
        super(element);

        var size = this.getAttr("data-set") ?? "";
        this.on("click", () => parent.setLayout(this, size))
    }
}